<template>
    <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" width="750px" :before-close="handleCancel">
        <el-table :data="tableData" stripe border :header-cell-style="$rowStyle.DEFAULT">
            <el-table-column prop="shippingMethod" :label="$t('BusinessPurchaseOrder2.means')" align="center" />
            <el-table-column prop="isDisable" :label="$t('table.statusText')" align="center">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isDisable"></el-switch>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer flex-center">
            <el-button @click="handleCancel">{{ $t('cancelText') }}</el-button>
            <el-button type="primary" @click="handleSend">{{ $t('okText') }}</el-button>
        </span>
    </el-dialog>
  </template>
  <script>
  import { userApi } from '@/api';
  export default {
    data() {
      return {
        dialogVisible: false,
        tableData: []
      };
    },
    mounted() {
    },
    methods: {
        handleCancel() {
            this.dialogVisible = false;
        },
        handleSend() {
            const DATA = this.tableData.map(item=>{
                return { ...item, isDisable: item.isDisable ? 0:1 }
            })
            userApi.updateShippingList(DATA).then(()=>{
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleCancel()
                this.$emit('reFresh')
            })
        },
    },
  };
  </script>
  